import React from 'react';
import Slider from 'react-slick';

import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables.js';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const OpenIconStyle = {
    fontSize: 24,
    cursor: 'pointer',
    color: StyleVariables.TextColor,
};

const NextArrow = ({ className, onClick }) => {
    return (
        <div className={className} onClick={onClick}>
            <NwIcon icon={byPrefixAndName.fasl['chevron-right']} style={OpenIconStyle} />
        </div>
    );
};

const PrevArrow = ({ className, onClick }) => {
    return (
        <div className={className} onClick={onClick}>
            <NwIcon icon={byPrefixAndName.fasl['chevron-left']} style={OpenIconStyle} />
        </div>
    );
};

const NwSlickSlider = ({ slidesToShow, slidesToScroll, responsive = undefined, children, ...rest }) => {
    const settings = {
        className: 'slider variable-width',
        infinite: false,
        slidesToShow,
        slidesToScroll,
        variableWidth: true,
        centerPadding: 30,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive,
    };

    return (
        <Slider {...settings} {...rest}>
            {children}
        </Slider>
    );
};

export default NwSlickSlider;
